import { render } from "./CaixaSection.vue?vue&type=template&id=5d3facda&scoped=true"
import script from "./CaixaSection.vue?vue&type=script&lang=js"
export * from "./CaixaSection.vue?vue&type=script&lang=js"

import "./CaixaSection.vue?vue&type=style&index=0&id=5d3facda&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d3facda"]])

export default __exports__